<template>
  <div
    class="z-20 -mr-px rounded-none first:rounded-l-lg last:rounded-r-lg [&>button]:rounded-none [&>button]:first:rounded-l-lg [&>button]:last:rounded-r-lg"
  >
    <FormSelect
      :id="id"
      v-model="value"
      :name="autocomplete"
      :options="formattedOptions"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import FormSelect from "@/design_system/v2/Form/Select.vue";

const props = defineProps<{
  modelValue: string;
  id?: string;
  autocomplete?: string;
  options: {
    value: string;
    label: string;
    group?: string;
  }[];
}>();

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

// Convert options from value/label format to id/label format for v2/Form/Select
const formattedOptions = computed(() =>
  props.options.map((option) => ({
    id: option.value,
    label: option.label,
    group: option.group,
  }))
);
</script>
